import { useState } from 'react'
import ElectronIPC from '../../services/ElectronIPC'
import { Button } from '@/UIComponents2/Button'

export default function ScreenControlDiagnosticsPageRobotjsControl() {
    const [coordInputPosition, set_coordInputPosition] = useState<{ x: number; y: number }>({ x: 0, y: 0 })

    const setCoordInputPositionHelper = (str: string, axis: 'x' | 'y') => {
        const v = Math.round(Number.parseFloat(str))
        if (!isNaN(v)) {
            set_coordInputPosition((c) => {
                const next = structuredClone(c)
                next[axis] = v
                return next
            })
        }
    }

    return (
        <div>
            <input
                style={{ width: '8ch' }}
                value={Math.round(coordInputPosition.x)}
                onChange={(ev) => setCoordInputPositionHelper(ev.target.value, 'x')}
            ></input>
            <input
                style={{ width: '8ch' }}
                value={Math.round(coordInputPosition.y)}
                onChange={(ev) => setCoordInputPositionHelper(ev.target.value, 'y')}
            ></input>
            <Button
                variant="rectangle"
                onClick={() => {
                    ElectronIPC.robotJSCommand('moveMouse', [coordInputPosition.x, coordInputPosition.y])
                }}
            >
                Go
            </Button>
        </div>
    )
}
